import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  fieldParent: {
    marginBottom: '38px',
    '@media (max-width: 768px)': {
      marginBottom: '32px',
    },
  },
  employerFieldParent: {
    marginBottom: '38px',
  },
  fieldHeader: {
    marginBottom: '32px',
    '@media (max-width: 768px)': {
      marginBottom: '16px',
    },
  },
  buttonParent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    '@media (max-width: 768px)': {
      justifyContent: 'center',
    },
  },
  button: {
    minWidth: '182px !important',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  projectName: {
    fontSize: '20px',
    lineHeight: '26px',
    fontWeight: 500,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    marginTop: '-30px',
  },
  loginButtonParent: {
    position: 'absolute',
    top: '30px',
    right: '30px',
    '@media (max-width: 768px)': {
      position: 'initial',
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '32px',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  orTextParent: {
    textAlign: 'center',
    position: 'relative',
    marginTop: '38px',
    marginBottom: '38px',
    width: '100%',
    '@media (max-width: 768px)': {
      marginTop: '32px',
      marginBottom: '32px',
    },
    '&::before': {
      position: 'absolute',
      content: '""',
      width: '70%',
      height: '1px',
      left: '50%',
      top: '58%',
      transform: 'translate(-50%, -50%)',
      borderTop: `1px dashed ${STYLE.COLOR.DIVIDER}`,
    },
  },
  orText: {
    padding: '0 6px',
    position: 'relative',
    zIndex: 1,
    background: STYLE.COLOR.WHITE,
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT1,
  },
  loginButton: {
    width: '100%',
  },
  buildInfo: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT3,
    marginTop: '16px',
    textAlign: 'center',
  },
  warning: {
    marginBottom: 24,
  },
  projectWarning: {
    marginBottom: 42,
  },
  lockCheckbox: {
    marginTop: '22px !important',
  },
}));
